import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportBoxMovement } from './BoxMovement.service';

export function useBoxMovementReport() {
  return useMutation(getQuestReportBoxMovement, {
    onSuccess() {
      notification.success({
        message: 'Relatório de movimento de caixa gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
